import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TokenStorage } from 'src/app/core/services/token.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {
  getdata: any;
  getkpidata:any;
  getdashdata: any;
  getalldash: any = [];
  charts:any=[];
  filterForm !:FormGroup;
  filterData: any = [
    {
      filterTypeID : 1,
      filterTypeName : "Present Day"
    },
    {
      filterTypeID : 2,
      filterTypeName: "Past 7 Days"
    },
    {
      filterTypeID : 3,
      filterTypeName: "Past 30 Days"
    }
  ];
  filter: any = 1;
  searchHotelList : any;
 
  constructor(private token:TokenStorage, private router:Router) {}
 
  ngOnInit() {
    // if (this.token.get()) {
    //   this.router.navigate(['/quotation/get-quote']);
    // }
  }
}
